import { render, staticRenderFns } from "./PromptList.vue?vue&type=template&id=7a4e48fc&"
import script from "./PromptList.vue?vue&type=script&lang=js&"
export * from "./PromptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports